import { useEffect, useState } from 'react'
import { CHARGING_DAYS, Day } from '@e3dc-react/shell/Libs/date/types'
import { useFormikContext } from 'formik'
import { WallboxSettingsFormModel } from '../models'

interface UseTransferChargingStrategyHook {
  setSelectedDays: (selectedDays: Set<string>) => void
}

/**
 * copy charge strategy form a day to other selected days
 */
export const useTransferChargingStrategy = (weekDayName: Day, name: keyof WallboxSettingsFormModel): UseTransferChargingStrategyHook => {
  const [selectedDays, setSelectedDays] = useState<Set<string>>(new Set())

  const {
    values: { chargeStrategyConfiguration },
    setFieldValue,
  } = useFormikContext<WallboxSettingsFormModel>()

  const weekDayIndex = CHARGING_DAYS.indexOf(weekDayName)

  useEffect(() => {
    if (!chargeStrategyConfiguration) return

    const currentConfiguration = chargeStrategyConfiguration.find(configuration => configuration.chargeStrategyWeekday === weekDayIndex)

    if (!currentConfiguration) return

    /* extract values from current configuration */
    const { chargeStrategyDelayedChargeAmount, chargeStrategyDirectChargeAmount, chargeStrategyDelayedChargeTime } = currentConfiguration

    /* set current configuration values to selected days */
    for (const configuration of chargeStrategyConfiguration) {
      const weekDay = CHARGING_DAYS[configuration.chargeStrategyWeekday]
      if (selectedDays.has(weekDay)) {
        setFieldValue(`${name}.${configuration.chargeStrategyWeekday}.chargeStrategyDelayedChargeAmount`, chargeStrategyDelayedChargeAmount)
        setFieldValue(`${name}.${configuration.chargeStrategyWeekday}.chargeStrategyDelayedChargeTime`, chargeStrategyDelayedChargeTime)
        setFieldValue(`${name}.${configuration.chargeStrategyWeekday}.chargeStrategyDirectChargeAmount`, chargeStrategyDirectChargeAmount)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, selectedDays, setFieldValue, weekDayIndex])

  return { setSelectedDays }
}
